import { IBase, IUser } from "@app/common";
import * as R from 'remeda';

export type UserFormValues = Partial<IUser> & { isDeleted: boolean };

export const transformUserFormValuesToPayload = (values: UserFormValues): Partial<IUser> => {
  return {
    firstname: values.firstname,
    lastname: values.lastname,
    email: values.email,
    phone: values.phone,
    code: values.code,
    shops: (values.shops || []).map((shop) => ({ _id: shop._id })),
    roles: (values.roles || [])
      .filter((role) => !R.isNullish(role["_id"]))
      .map((role) => ({ _id: role["_id"] })),
    deletedAt: values.isDeleted ? new Date() : null,
  }
}

export const transformToUpdatableFormUser = (user?: Partial<IUser>): UserFormValues => {
  return {
    firstname: user?.firstname || '',
    lastname: user?.lastname || '',
    email: user?.email || '',
    phone: user?.phone || '',
    code: user?.code ? user.code.toString() : '',
    shops: user?.shops || [],
    roles: user?.roles || [],
    isDeleted: !!user?.deletedAt,
  }
}
